// extracted by mini-css-extract-plugin
export default {"searchFooter":"SearchFooter-module__searchFooter___3Zba1"};